import { formatPrice } from '../../lib/number-formatting';

export const formatAmount = (cents: number) => formatPrice(cents, 100, true);
